import React, { useState, useEffect, Component } from 'react';
import { useApolloClient } from '@apollo/client';
import { getPaymentProviderInfo } from './paymentProvider.util';
import { PAYMENT_GATEWAY_SELECTOR } from '../../../components/myeirconstant/myEirConstant';
import PaymentIframeContainer from '../../payment-flow/PaymentIframeContainer';
import MyEirErrorHandle from '../../eir-porting/MyEirErrorHandle';
import Loading from '../../../components/loading/Loading';
import StancerPaymentContainer from '../stancer-payment-gateway/StancerPaymentContainer';

const { ELAVON } = PAYMENT_GATEWAY_SELECTOR;

/**
 * @name PaymentGatewaySelectorPaymentFlow - Component to display one off payment
 * @param {*} props - React props
 * @returns {Component} - Return component based on provider either ELAVON or STANCER
 */
const PaymentGatewaySelectorPaymentFlow = props => {
    const graphql = useApolloClient();
    const [provider, setProvider] = useState('');
    const [openError, setOpenError] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPaymentProviderInfo({
            graphql,
            setProvider,
            setOpenError,
            setLoading,
        });
    }, []);

    return (
        <React.Fragment>
            {loading ? (
                <Loading />
            ) : (
                <>
                    {provider === ELAVON ? (
                        <PaymentIframeContainer
                            payableAmount={props?.payableAmount}
                            handleBack={props?.handleBack}
                            setStatus={props?.setStatus}
                            handleNext={props?.handleNext}
                            setHeader={props?.setHeader}
                            handleMultiPaymentData={props?.handleMultiPaymentData}
                            toggle={props?.toggle}
                            setPaidAmount={props?.setPaidAmount}
                        />
                    ) : (
                        <StancerPaymentContainer
                            payableAmount={props?.payableAmount}
                            handleBack={props?.handleBack}
                            setStatus={props?.setStatus}
                            handleNext={props?.handleNext}
                            setHeader={props?.setHeader}
                            handleMultiPaymentData={props?.handleMultiPaymentData}
                            toggle={props?.toggle}
                            setPaidAmount={props?.setPaidAmount}
                        />
                    )}
                    {openError ? <MyEirErrorHandle open={openError} setOpen={setOpenError} /> : ''}
                </>
            )}
        </React.Fragment>
    );
};
export default PaymentGatewaySelectorPaymentFlow;
